module.exports = {
  expo: {
    name: "primer-expo",
    slug: "primer-expo",
    version: "1.0.0",
    orientation: "portrait",
    userInterfaceStyle: "light",
    splash: {
      image: "./assets/splash.png",
      resizeMode: "contain",
      backgroundColor: "#FFFFFF",
    },
    extra: {
      storybookEnabled: process.env.STORYBOOK_ENABLED,
    },
    assetBundlePatterns: ["**/*"],
    ios: {
      supportsTablet: true,
    },
    android: {
      adaptiveIcon: {
        foregroundImage: "./assets/adaptive-icon.png",
        backgroundColor: "#FFFFFF",
      },
    },
    web: {
      build: {
        publicPath: "./",
      },
      indexHtml: "web/index.html",
    },
    plugins: [
      "expo-localization",
      [
        "expo-av",
        {
          microphonePermission: "Allow $(PRODUCT_NAME) to access your microphone.",
        },
      ],
    ],
  },
};
